<script lang="ts">
  // components
  import FormatMoney from "@shared/svelte/Components/FormatMoney.svelte";

  // types
  import type { Invoice } from "@shared/types/Invoice";

  // props
  export let invoice: Invoice;

  const lineItemsCount = invoice.line_items ? invoice.line_items.length : 0;
  const anyDiscounts = invoice.line_items?.some(line_item => parseFloat(line_item.discount) != 0);
  const anyDeposits = invoice.line_items?.some(line_item => parseFloat(line_item.deposit) != 0);
  const anyUnitsOfMeasure = invoice.line_items?.some(line_item => !!line_item.unit_of_measure);
</script>

<table class="fizz-table fizz-text-medium fizz-stack-32">
  <thead>
    <tr>
      <th class="fizz-surface-blue" style="width: 40%">Item</th>
      <th class="fizz-surface-blue">Qty</th>
      {#if anyUnitsOfMeasure}
        <th class="fizz-surface-blue"> Unit of Measure</th>
      {/if}
      <th class="fizz-surface-blue">Price (per unit)</th>
      {#if anyDeposits && !invoice.is_read_only}
        <th class="fizz-surface-blue">Deposit (per unit)</th>
      {/if}
      {#if anyDiscounts && !invoice.is_read_only}
        <th class="fizz-surface-blue">Discount (per unit)</th>
      {/if}
      <th class="fizz-surface-blue fizz-text-right">Total</th>
    </tr>
  </thead>
  <tbody>
    {#if lineItemsCount > 0}
      {#each invoice.line_items as lineItem}
        <tr>
          <td data-label="Item">
            <div>
              <strong>{lineItem.product_name}</strong>{#if lineItem.sku}<br />SKU: {lineItem.sku}{/if}
            </div>
          </td>
          <td data-label="Qty">{lineItem.num_units}</td>
          {#if anyUnitsOfMeasure}
            <td data-label="Unit of Measure">{lineItem.unit_of_measure || ""}</td>
          {/if}
          <td data-label="Price (per unit)">
            <FormatMoney input={parseFloat(lineItem.full_price)} formatType={"5"} />
          </td>
          {#if anyDeposits && !invoice.is_read_only}
            <td data-label="Deposit (per unit)">
              {#if lineItem.deposit && parseFloat(lineItem.deposit) != 0}
                <FormatMoney input={parseFloat(lineItem.deposit)} formatType={"5"} />
              {:else}
                <div class="fizz-hide-on-large">
                  <FormatMoney input={0} formatType={"5"} />
                </div>
              {/if}
            </td>
          {/if}
          {#if anyDiscounts && !invoice.is_read_only}
            <td data-label="Discount (per unit)">
              {#if parseFloat(lineItem.discount) != 0}
                <FormatMoney input={parseFloat(lineItem.discount)} formatType={"5"} />
              {:else}
                <div class="fizz-hide-on-large">
                  <FormatMoney input={parseFloat(lineItem.discount)} formatType={"5"} />
                </div>
              {/if}
            </td>
          {/if}
          <td class="fizz-text-right" data-label="Total">
            <FormatMoney input={parseFloat(lineItem.volume)} formatType={"5"} />
          </td>
        </tr>
      {/each}
    {:else}
      <tr>
        <td class="fizz-nowrap">Product information unavailable for this invoice.</td>
      </tr>
    {/if}
  </tbody>
</table>
